(() => {
  const ready = () => {
    document.querySelectorAll('[data-cr-pdp-bundle-add]').forEach((button) => {
      if (button.dataset.crPdpBundleBound === 'true') return;
      button.dataset.crPdpBundleBound = 'true';
      button.addEventListener('click', () => {
        const panel = button.closest('.cr-pdp__panel');
        const form = panel?.querySelector('.cr-buybox');
        const variantId = button.dataset.crPdpBundleVariant;
        const quantity = Number(button.dataset.crPdpBundleQuantity || 1);
        if (!form || !variantId || !Number.isInteger(quantity) || quantity < 1) return;
        const variant = form.querySelector(`input[name="id"][value="${CSS.escape(variantId)}"]`);
        const quantityInput = form.querySelector('[data-cr-qty-input]');
        const submit = form.querySelector('[type="submit"]');
        if (!variant || variant.disabled || !quantityInput || !submit || submit.disabled) return;
        variant.checked = true;
        variant.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.value = String(quantity);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        window.setTimeout(() => form.requestSubmit(), 0);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})();
